(() => {
  document.addEventListener(
    'click',
    (event) => {
      if (!event.target.closest?.('.custom-language-selector__option')) return;

      document.documentElement.dataset.tayebSkipViewTransition = 'true';
      sessionStorage.setItem('tayeb-skip-view-transition', 'true');
      window.setTimeout(() => {
        delete document.documentElement.dataset.tayebSkipViewTransition;
        sessionStorage.removeItem('tayeb-skip-view-transition');
      }, 5000);
    },
    { capture: true }
  );

  document.addEventListener('click', (event) => {
    const backLink = event.target.closest?.('[data-tayeb-back]');
    if (!backLink) return;

    const referrer = document.referrer ? new URL(document.referrer) : null;
    if (referrer?.origin === window.location.origin && window.history.length > 1) {
      event.preventDefault();
      window.history.back();
    }
  });

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('tayeb-motion-ready');

  const selector = [
    "main[data-template='index'] .shopify-section:not(:first-child)",
    "main[data-template='collection'] > .shopify-section:first-child",
    "main[data-template='collection'] .facets-block-wrapper",
    "main[data-template='collection'] .facets-toggle",
    "main[data-template='collection'] .product-grid__item",
    "main[data-template='product'] .product-information__media",
    "main[data-template='product'] .product-details",
    "main[data-template='product'] .product-recommendations .resource-list__item",
    "main[data-template='cart'] .cart-page__items",
    "main[data-template='cart'] .cart-page__summary",
  ].join(',');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('tayeb-reveal--visible');
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08,
    }
  );

  const register = (scope = document) => {
    const elements = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) elements.unshift(scope);

    elements.forEach((element, index) => {
      if (element.classList.contains('tayeb-reveal')) return;
      element.classList.add('tayeb-reveal');
      const cardIndex = element.classList.contains('product-grid__item')
        ? [...element.parentElement.children].indexOf(element)
        : index;
      element.style.setProperty('--tayeb-reveal-delay', `${Math.min(cardIndex % 4, 3) * 55}ms`);
      observer.observe(element);
    });
  };

  const updateHeaderState = () => {
    document.documentElement.dataset.tayebScrolled = window.scrollY > 48 ? 'true' : 'false';
  };

  register();
  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });
  window.addEventListener('pageshow', updateHeaderState);

  document.addEventListener('shopify:section:load', (event) => {
    register(event.target);
  });

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) register(node);
      });
    });
  });
  mutationObserver.observe(document.querySelector('main') || document.body, {
    childList: true,
    subtree: true,
  });
})();
